export default __webpack_public_path__ + "static/media/pn.9496dff5.svg";